import { render, staticRenderFns } from "./parts_edit_items.vue?vue&type=template&id=e3c8e432&scoped=true&"
import script from "./parts_edit_items.vue?vue&type=script&lang=js&"
export * from "./parts_edit_items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c8e432",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3c8e432')) {
      api.createRecord('e3c8e432', component.options)
    } else {
      api.reload('e3c8e432', component.options)
    }
    module.hot.accept("./parts_edit_items.vue?vue&type=template&id=e3c8e432&scoped=true&", function () {
      api.rerender('e3c8e432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/body/addon/parts_reserv/editor/parts_edit_items.vue"
export default component.exports